import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ImportPlanReviewRequirementCandidatesMutationVariables = Types.Exact<{
  input: Types.ImportPlanReviewRequirementCandidatesInput;
}>;


export type ImportPlanReviewRequirementCandidatesMutation = { __typename?: 'mutation_root', import_plan_review_requirement_candidates?: { __typename?: 'ImportPlanReviewRequirementCandidatesOutput', success: boolean, imported_count?: number | null, replaced_count?: number | null, skipped_count?: number | null, error?: string | null } | null };


export const ImportPlanReviewRequirementCandidatesDocument = gql`
    mutation importPlanReviewRequirementCandidates($input: ImportPlanReviewRequirementCandidatesInput!) {
  import_plan_review_requirement_candidates(input: $input) {
    success
    imported_count
    replaced_count
    skipped_count
    error
  }
}
    `;
export type ImportPlanReviewRequirementCandidatesMutationFn = Apollo.MutationFunction<ImportPlanReviewRequirementCandidatesMutation, ImportPlanReviewRequirementCandidatesMutationVariables>;

/**
 * __useImportPlanReviewRequirementCandidatesMutation__
 *
 * To run a mutation, you first call `useImportPlanReviewRequirementCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPlanReviewRequirementCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPlanReviewRequirementCandidatesMutation, { data, loading, error }] = useImportPlanReviewRequirementCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPlanReviewRequirementCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<ImportPlanReviewRequirementCandidatesMutation, ImportPlanReviewRequirementCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPlanReviewRequirementCandidatesMutation, ImportPlanReviewRequirementCandidatesMutationVariables>(ImportPlanReviewRequirementCandidatesDocument, options);
      }
export type ImportPlanReviewRequirementCandidatesMutationHookResult = ReturnType<typeof useImportPlanReviewRequirementCandidatesMutation>;
export type ImportPlanReviewRequirementCandidatesMutationResult = Apollo.MutationResult<ImportPlanReviewRequirementCandidatesMutation>;
export type ImportPlanReviewRequirementCandidatesMutationOptions = Apollo.BaseMutationOptions<ImportPlanReviewRequirementCandidatesMutation, ImportPlanReviewRequirementCandidatesMutationVariables>;